import { useState } from 'react';
import { Typography, Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useQuery, useQueryClient } from 'react-query';
import { getCwTrainingEmails } from '../../../api/apiRequests/cwTrainingEmails';
import { CwTrainingEmail } from '../../../lib/interfaces/CwTrainingEmail';
import {
	IPagination,
	TPaginationSettings,
} from '../../../lib/interfaces/Pagination';
import CwTrainingEmailsList from './CwTrainingEmailsList';
import { hour } from '../../../lib/helpers/time.helper';

const CwTrainingEmails = () => {
	const [pagination, setPagination] = useState<TPaginationSettings | null>(null);
	const queryClient = useQueryClient();
	const { data: trainingEmails, refetch } = useQuery<
		IPagination<CwTrainingEmail>,
		Error
	>(
		['trainingEmails', pagination?.page, pagination?.limit],
		() => getCwTrainingEmails(pagination),
		{
			staleTime: hour,
		},
	);

	const handleSetPagination = (paging: TPaginationSettings) => {
		setPagination(paging);
	};

	return (
		<div style={{ width: '100%' }}>
			<Typography variant="h4" sx={{ fontWeight: '500', marginBottom: '15px' }}>
				Training emails{' '}
				<Button
					size="small"
					onClick={() => {
						if (pagination?.page === 1) {
							refetch();
						} else if (trainingEmails) {
							queryClient.invalidateQueries([
								'trainingEmails',
								1,
								trainingEmails?.meta.itemsPerPage,
							]);
							setPagination({ page: 1, limit: trainingEmails.meta.itemsPerPage });
						} else {
							refetch();
						}
					}}
					startIcon={<RefreshIcon />}
					variant="contained"
					color="inherit"
					disableElevation
				>
					Refresh
				</Button>
			</Typography>
			{trainingEmails && trainingEmails.items?.length ? (
				<CwTrainingEmailsList
					data={trainingEmails}
					refetchEmails={refetch}
					setPagination={handleSetPagination}
				/>
			) : (
				<div>No emails yet...</div>
			)}
		</div>
	);
};

export default CwTrainingEmails;
